import { getData, waitForData } from '@ifit/native-webview-interface';
import { useEffect, useState } from 'react';
import { useConfig } from '../store/reducers/config';

export const storageKey = 'wizards/last-favorite-change-timestamp';
export interface IFeatureFlags {
  [flagName: string]: boolean | string;
}

let getDataFunc: typeof getData = getData;

export function setStorageFunctions(newGetData: typeof getData): void {
  getDataFunc = newGetData || getData;
}

export function updateTimestamp(): void {
  getDataFunc([`store://put/${storageKey}?${Date.now()}`]);
}

export async function readTimestamp(): Promise<number> {
  const key = `store://get/${storageKey}`;
  const data = await waitForData([key]);
  if (!data[key]) {
    return 0;
  }
  return parseInt(data[key], 10);
}

export const useFeatureFlags = (flags: string[]): IFeatureFlags => {
  const { featureFlags: configuredFeatureFlags } = useConfig();
  const [featureFlags, setFeatureFlags] = useState(configuredFeatureFlags);
  // Condition: Check if there are configured feature flags in env.
  // If parseJSON from native failed result will be of type string instead of obj.
  const [featureFlagsLoading, setFeatureFlagsLoading] = useState(
    Object.keys(configuredFeatureFlags).length === 0 ||
      typeof configuredFeatureFlags === 'string',
  );
  useEffect(() => {
    if (featureFlagsLoading) {
      if (flags.length > 0) {
        (async () => {
          const localData = (await waitForData(flags)) as Promise<
            IFeatureFlags
          >;
          if (localData) {
            setFeatureFlags({ ...featureFlags, ...localData });
          }
          setFeatureFlagsLoading(false);
        })();
      }
    }
  }, [featureFlags, featureFlagsLoading, flags]);
  return featureFlags;
};
